exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-workspace-modal{width:700px}.c-workspace-modal>.c-modal-content_children{padding:0}.c-workspace-modal>.c-modal-content_children>.c-input-box{padding:0 35px}.c-workspace-modal>.c-modal-content_children>.c-buttons-box{border-top:1px solid rgb(90.6666666667%,91.3725490196%,93.8823529412%);padding:20px 35px;display:flex;justify-content:flex-end;margin:40px 0 auto}.c-workspace-modal>.c-modal-content_children>.c-buttons-box>.a-button-secondary{margin-right:20px}", ""]);

// exports
